export enum IntegrationKey {
  JOHN_DEERE = 'jdoc',
  PERFECT_FLIGHT = 'perfectFlight',
  TRAP_VIEW = 'trapview'
}
